import { defineComponent, h } from 'vue'
import { mapActions } from 'vuex'

// 3rd parties
import ga from '@/3rd-parties/ga.ts'

// node-modules
import Toaster from '@/node-modules/toaster.ts'

// constants
import { APPLICATION_PAGES } from '@/constants'

export default (component: any) => defineComponent({
  data() {
    return {
      isApprovingQuestion: false,
      isRevertingQuestion: false,
      isDismissingQuestion: false,
    }
  },
  methods: {
    ...mapActions(['updateQuestionAction']),
    async handleApproveQuestion(question: any) {
      ga.trackEvent(APPLICATION_PAGES.QA, 'Question > Approve > Submit')

      const payload = {
        question,
        updatedProperties: {
          status: 'approved',
        },
      }
      try {
        this.isApprovingQuestion = true
        await this.updateQuestionAction(payload)

        Toaster.success('Question approved')
      } catch {
        Toaster.error('The question has not been approved. Please try again.')
      }

      this.isApprovingQuestion = false
    },
    async handleDismissQuestion(question: any) {
      ga.trackEvent(APPLICATION_PAGES.QA, 'Question > Dismiss > Submit')
      const payload = {
        question,
        updatedProperties: {
          status: 'dismissed',
        },
      }
      try {
        this.isDismissingQuestion = true
        await this.updateQuestionAction(payload)

        Toaster.success('Question dismissed')
      } catch {
        Toaster.error('The question has not been dismissed. Please try again.')
      }

      this.isDismissingQuestion = false
    },
    async handleRevertQuestion(question: any) {
      ga.trackEvent(APPLICATION_PAGES.QA, 'Question > Revert > Submit')
      const payload = {
        question,
        updatedProperties: {
          status: null,
        },
      }
      try {
        this.isRevertingQuestion = true
        await this.updateQuestionAction(payload)

        Toaster.success('Question moved back to Pending')
      } catch {
        Toaster.error('The question has not been moved back to Pending. Please try again.')
      }

      this.isRevertingQuestion = false
    },
  },
  render() {
    return h(component, {
      ...this.$attrs,
      isApprovingQuestion: this.isApprovingQuestion,
      isDismissingQuestion: this.isDismissingQuestion,
      isRevertingQuestion: this.isRevertingQuestion,
      handleApproveQuestion: this.handleApproveQuestion,
      handleDismissQuestion: this.handleDismissQuestion,
      handleRevertQuestion: this.handleRevertQuestion,
    })
  },
})
